export const BASE_PRICE = 995;
export const DEPOSIT = 250;

export const ADDONS = [
  { id: "bacteria", name: "Bacteria Upgrade", price: 105, group: "recommended", blurb: "Adds targeted bacterial screening to your included water panel." },
  { id: "pfas", name: "PFAS / Forever Chemicals", price: 670, group: "recommended", blurb: "Screens for a broad class of persistent fluorinated chemicals." },
  { id: "microplastics", name: "Microplastics", price: 1350, group: "recommended", blurb: "Advanced laboratory screening for microplastic particles in drinking water." },
  { id: "allergens-basic", name: "Basic Indoor Allergens", price: 760, group: "recommended", blurb: "Screens indoor dust for common allergen sources." },
  { id: "voc-lab", name: "VOC Air Lab Test", price: 650, group: "recommended", blurb: "Laboratory-based analysis for volatile organic compounds in indoor air." },
  { id: "pfas-expanded", name: "Expanded PFAS + GenX", price: 965, group: "Water Chemistry" },
  { id: "pesticides", name: "Pesticides & Herbicides", price: 685, group: "Water Chemistry" },
  { id: "radon-water", name: "Radon in Water", price: 235, group: "Water Chemistry" },
  { id: "radiological", name: "Advanced Radiological", price: 1855, group: "Water Chemistry" },
  { id: "legionella-comp", name: "Comprehensive Legionella", price: 720, group: "Water Microbiology" },
  { id: "legionella-target", name: "Targeted Legionella", price: 605, group: "Water Microbiology" },
  { id: "microbiology-total", name: "Total Microbiology", price: 2175, group: "Water Microbiology" },
  { id: "biofilm", name: "Biofilm Bacteria", price: 800, group: "Water Microbiology" },
  { id: "mold-water", name: "Mold/Fungus in Water", price: 650, group: "Water Microbiology" },
  { id: "allergens-expanded", name: "Expanded Indoor Allergens", price: 1440, group: "Air & Allergens" },
  { id: "mold-dust", name: "Mold Dust", price: 985, group: "Mold & Building Materials" },
  { id: "mold-swab", name: "Mold Surface Swab", price: 220, group: "Mold & Building Materials" },
  { id: "mold-tape", name: "Mold Surface Tape", price: 215, group: "Mold & Building Materials" },
  { id: "lead-dust", name: "Lead Dust Wipe", price: 205, group: "Mold & Building Materials" },
  { id: "lead-paint", name: "Lead Paint Chip", price: 200, group: "Mold & Building Materials" },
  { id: "asbestos-basic", name: "Basic Asbestos", price: 190, group: "Mold & Building Materials" },
  { id: "asbestos-advanced", name: "Advanced Asbestos", price: 295, group: "Mold & Building Materials" },
];

export const GROUPS = ["Water Chemistry", "Water Microbiology", "Air & Allergens", "Mold & Building Materials"];
export const BY_ID = Object.fromEntries(ADDONS.map((a) => [a.id, a]));

// superset → subset it already includes
export const SUPERSEDES = {
  "pfas-expanded": { sub: "pfas", note: "Expanded PFAS includes the standard PFAS panel." },
  "allergens-expanded": { sub: "allergens-basic", note: "Expanded Indoor Allergens includes the basic allergen screen." },
  "asbestos-advanced": { sub: "asbestos-basic", note: "Advanced Asbestos includes the basic asbestos screen." },
  "legionella-comp": { sub: "legionella-target", note: "Comprehensive Legionella includes the targeted test." },
};
const SUBSET_OF = Object.fromEntries(Object.entries(SUPERSEDES).map(([sup, { sub, note }]) => [sub, { sup, note }]));

export const toggleAddon = (selected, id) => {
  if (selected.includes(id)) return { selected: selected.filter((x) => x !== id), note: "" };
  let next = [...selected, id];
  let note = "";
  if (SUPERSEDES[id] && next.includes(SUPERSEDES[id].sub)) { next = next.filter((x) => x !== SUPERSEDES[id].sub); note = SUPERSEDES[id].note; }
  if (SUBSET_OF[id] && next.includes(SUBSET_OF[id].sup)) { next = next.filter((x) => x !== SUBSET_OF[id].sup); note = SUBSET_OF[id].note.replace("includes", "already covered by: replaced"); }
  return { selected: next, note };
};

export const priceSummary = (selected) => {
  const addons = selected.map((id) => BY_ID[id]).filter(Boolean);
  const addonTotal = addons.reduce((s, a) => s + a.price, 0);
  return { addons, addonTotal, totalValue: BASE_PRICE + addonTotal, dueToday: DEPOSIT + addonTotal, remaining: BASE_PRICE - DEPOSIT };
};

export const usd = (n) => `$${n.toLocaleString()}`;
